define('app/views/checkout_login_form_view',['app/setup', 'app/models/user'], function(takhfifan) {

  takhfifan.checkoutLoginFormView = takhfifan.BaseView.extend({

    events: {
      // 'keypress': 'submit',
      'submit .inline-form': 'submit',
      'click .social-login': 'socialLoginSubmit'
    },

    initialize: function() {
      var _this = this;
      this.model.set('loginUrl', this.$('form').first().prop('action'));

      takhfifan.eventHub.on('formkey', function(formKey) {
        this.model.set('formKey', formKey);
      }, this);

      takhfifan.eventHub.on('socialconnect', function(socialconnect) {
        this.activateSocialButtons(socialconnect);
      }, this);

      takhfifan.eventHub.on('customer:login', function(customer) {
        if (this.$el.is(':visible')) {
          this.hideSuccess(customer);
        }
      }, this);

      takhfifan.eventHub.on('customer:loginForm', function() {
        this.render();
      }, this);

      takhfifan.eventHub.on('customer:loginError', function(errors) {
          this.renderErrors(errors);
      }, this);

      takhfifan.eventHub.on('customer:loginEnd', function() {
        this.$('#tkhLoginBtn').empty().append(_this.loginBtnContent);
      }, this);

      this.loginBtnContent = this.$('.tkhLoginBtn').html();
      this.loggingIn = false;

      Backbone.Validation.bind(this);
      this.$el.find('.inline-form input[required]').on('change invalid', function() {
        var textfield = $(this).get(0);

        textfield.setCustomValidity('');

        if (!textfield.validity.valid) {
          var $name = $(this).attr('name');
          if($name == 'username'){
            textfield.setCustomValidity('لطفا ایمیل خود را وارد کنید');
          }else if ($name == 'password'){
            textfield.setCustomValidity('لطفا کلمه عبور خود را (بیش از ۶ حرف) وارد کنید');
          }else{
            textfield.setCustomValidity('لطفا مقدار معتبر در این فیلد وارد کنید.');
          }
        }
      });
    },

    renderErrors: function(errors) {
      this.loggingIn=false;
      this.$('.tkhLoginBtn').prop('disabled',false).empty().append(this.loginBtnContent);
      this.$('.success').empty().hide();
      var $errors = this.$('.alert-error');
      $errors.empty();
      _.each(errors, function(e) {
        var preFormattedError='<div class="alert alert-red"><span class="icon-info"></span><p>'+ e + '</p></div>';
        var $div = $('<div></div>');
        $div.html(preFormattedError);
        $errors.append($div);
      });
      $errors.show();
    },

    render: function() {
      var _this = this;
      this.overlay = $('.modal-overlay');
      this.$el.fadeIn(300, function() {
        _this.$('input[name=username]').focus();
      });
    },

    hideSuccess: function(customer) {
      this.$('.alert-error').empty().hide();
      var siteName = $('.yadisa-checkout-page').length? 'یادیسا': 'تخفیفان';
      takhfifan.eventHub.trigger('message:show', {
        type: 'success',
        msg:  'با موفقیت وارد ' + siteName + ' شدید'

      });
    },

    submit: function(e) {
      e.preventDefault();
      this.$el.find('.inline-form input[required]').each(function () {
        if(!$(this)[0].checkValidity()){
          return;
        }
      });
      this.$('.alert-error').empty().fadeOut();
      this.$('.tkh-error').remove();
      this.$('.error').removeClass('error');
      this.$('.invalid').removeClass('invalid');
      if(!this.loggingIn) {
          /*if (e.type != 'click' && e.which != 13) {
            return;
          }*/
        this.model.set('username',this.$('input[name="username"]').first().val());
        this.model.set("password",this.$('input[name="password"]').first().val());
        this.model.validate();
        if (this.model.isValid(['username', 'password'])) {
          this.loggingIn=true;
          this.$('.tkhLoginBtn').prop('disabled',true);
          this.$('.tkhLoginBtn').empty().append('<span class="spinner"></span>');
          this.model.login();
          this.setResetSessionFlag();
        } else {
          e.preventDefault();
        }
      }
    },

    activateSocialButtons: function(data) {
      this.$('a.tkh-google-login').prop('href', data.google);
      this.$('a.tkh-facebook-login').prop('href', data.facebook);
      this.$('a.tkh-twitter-login').prop('href', data.twitter);
    },

    socialLoginSubmit: function (e) {
      e.preventDefault();
      this.setResetSessionFlag();
      window.location.href = $(e.currentTarget).attr('href');
    } 

  });
});

